import { render, staticRenderFns } from "./SurveyForm.vue?vue&type=template&id=2c49f6de&scoped=true"
import script from "./SurveyForm.vue?vue&type=script&lang=js"
export * from "./SurveyForm.vue?vue&type=script&lang=js"
import style0 from "./SurveyForm.vue?vue&type=style&index=0&id=2c49f6de&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c49f6de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c49f6de')) {
      api.createRecord('2c49f6de', component.options)
    } else {
      api.reload('2c49f6de', component.options)
    }
    module.hot.accept("./SurveyForm.vue?vue&type=template&id=2c49f6de&scoped=true", function () {
      api.rerender('2c49f6de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/SurveyForm.vue"
export default component.exports